import { render, staticRenderFns } from "./modalRegistrarmeComponent.vue?vue&type=template&id=4af53d26&scoped=true"
import script from "./modalRegistrarmeComponent.vue?vue&type=script&lang=js"
export * from "./modalRegistrarmeComponent.vue?vue&type=script&lang=js"
import style0 from "./modalRegistrarmeComponent.vue?vue&type=style&index=0&id=4af53d26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af53d26",
  null
  
)

export default component.exports